import { getPhotoUrl, downloadImage } from "../../components/autocomplete/utils";
import { __ } from '@wordpress/i18n';

export const downloadImages = async (storedState) => {
	const [{ placeDetails, templateResponse, visitedSites, importStatus, importPercent }, dispatch] = storedState;
	let percentage = importPercent;
	if (placeDetails.photos) {
		let newPlaceDetails = { ...placeDetails };
		for (const image in placeDetails.photos) {
			if (Object.hasOwnProperty.call(placeDetails.photos, image)) {
				const element = placeDetails.photos[image];
				const photoReference = element.photo_reference;
				const index = placeDetails.photos.indexOf(element);
				await getPhotoUrl(photoReference).then(async (imageUrl) => {
					percentage += 2
					dispatch({
						type: 'set',
						importPercent: percentage,
						importStatus: sprintf(__('Downloading Gallery Image %s of %s', 'astra-sites'), (index + 1), placeDetails.photos.length),
					})
					if (typeof imageUrl !== 'undefined') {
						await downloadImage(imageUrl, index).then(result => {
							if (result.success === true) {

								for (const photo in newPlaceDetails.photos) {
									if (newPlaceDetails.photos[photo].photo_reference === photoReference) {
										newPlaceDetails.photos[photo].googleImage = imageUrl;
										newPlaceDetails.photos[photo].id = result.data.attachmentData.id;
									}
								}
							}
						})
					}
				});
			}
		}

		dispatch({
			type: 'set',
			placeDetails: newPlaceDetails,
			businessImagesDownloaded: true,
		})

	} else {
		dispatch({
			type: 'set',
			businessImagesDownloaded: true,
		})
	}

}

export const getDemo = async (id, storedState) => {
	const [{ templateResponse, visitedSites }, dispatch] = storedState;

	if (null !== templateResponse) {
		return;
	}

	if (visitedSites[id]) {
		dispatch({
			type: 'set',
			templateResponse: visitedSites[id],
		})
		return;
	}

	const data = new FormData();
	data.append("action", "astra-sites-api-request");
	data.append("url", 'astra-sites/' + id);

	await fetch(ajaxurl, {
		method: 'post',
		body: data
	})
		.then((response) => response.json())
		.then((data) => {
			if (data.success) {
				visitedSites[id] = data.data;
				dispatch({
					type: 'set',
					templateId: id,
					templateResponse: data.data,
					visitedSites: visitedSites,
				})
			}
		})
		.catch((error) => {
			console.error(error);
		});
}

export const requestCompletions = (storedState) => {
	const stateData = storedState[0];
	const { businessName, businessWork, businessAddress } = stateData;

	const placeInformation = {
		'name': businessName,
		'address': businessAddress,
		'business-work': businessWork
	}

	fetch(
		starterTemplates.requestCompletions,
		{
			method: 'POST',
			body: new URLSearchParams({
				'demo-id': starterTemplates.demoId,
				'website-information': JSON.stringify(placeInformation),
			}),
			headers: {
				'X-WP-Nonce': starterTemplates.restNonce
			}
		}
	);
}

export const installAstra = (storedState) => {

	const [{ importPercent }, dispatch] = storedState;
	const themeSlug = 'astra';
	let percentage = importPercent;

	if ('not-installed' == starterTemplates.themeStatus) {
		if (wp.updates.shouldRequestFilesystemCredentials && !wp.updates.ajaxLocked) {
			wp.updates.requestFilesystemCredentials();
		}
		percentage += 5;
		dispatch({
			type: 'set',
			importPercent: percentage,
			importStatus: __('Installing Astra Theme...', 'astra-sites'),
		})
		wp.updates.installTheme({
			slug: themeSlug
		})
		jQuery(document).on('wp-theme-install-success', function (event, response) {
			dispatch({
				type: 'set',
				themeStatus: response,
				importStatus: __('Astra Theme Installed.', 'astra-sites'),
			})
		});

	}

	if ("installed-but-inactive" == starterTemplates.themeStatus) {
		// WordPress adds "Activate" button after waiting for 1000ms. So we will run our activation after that.
		setTimeout(function () {

			const data = new FormData();
			data.append("action", "astra-sites-activate-theme");
			data.append("_ajax_nonce", astraSitesVars._ajax_nonce);

			fetch(ajaxurl, {
				method: 'post',
				body: data
			})
				.then((response) => response.json())
				.then((data) => {
					dispatch({
						type: 'set',
						themeStatus: data,
						importStatus: __('Astra Theme Installed.', 'astra-sites'),
					})
				})
				.catch((error) => {
					console.error(error);
				});

		}, 3000);
	}

	if ("installed-and-active" == starterTemplates.themeStatus) {
		dispatch({
			type: 'set',
			themeStatus: true
		})
	}
}
